import './ConstructionHeroFx.css';

const DUST = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  left: `${4 + ((i * 17) % 92)}%`,
  delay: `${(i % 9) * 0.45}s`,
  duration: `${7 + (i % 5) * 1.4}s`,
  size: 2 + (i % 3),
  opacity: 0.25 + (i % 4) * 0.12,
}));

/**
 * Decorative construction atmosphere for the home hero:
 * blueprint grid, drifting dust, soft light sweep, and a crane silhouette.
 */
export default function ConstructionHeroFx() {
  return (
    <div className="hero-fx" aria-hidden="true">
      <div className="hero-fx-blueprint" />
      <div className="hero-fx-beams" />
      <div className="hero-fx-sweep" />
      <svg className="hero-fx-crane" viewBox="0 0 280 160" fill="none">
        <path
          d="M48 148 V42 H62 V148 M48 42 H210 M62 56 H198 M210 42 V58"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M210 58 L210 118 M210 58 L248 118 M198 118 H258"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M210 78 V132"
          className="hero-fx-crane-cable"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        <rect
          className="hero-fx-crane-hook"
          x="198"
          y="128"
          width="24"
          height="14"
          rx="2"
          fill="currentColor"
          opacity="0.55"
        />
        <circle cx="55" cy="42" r="4" fill="currentColor" opacity="0.7" />
      </svg>
      <div className="hero-fx-dust">
        {DUST.map((p) => (
          <span
            key={p.id}
            className="hero-fx-dust-bit"
            style={{
              left: p.left,
              width: p.size,
              height: p.size,
              opacity: p.opacity,
              animationDelay: p.delay,
              animationDuration: p.duration,
            }}
          />
        ))}
      </div>
    </div>
  );
}
